import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top on every route change UNLESS the URL contains
 * a hash (e.g. /priser#faq). For hash links we let the browser/in-page
 * handler do its own anchor scroll so we don't fight the user's intent.
 *
 * Mounted once inside <BrowserRouter>; renders nothing.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // `auto` (instant) feels right on route transitions — smooth scroll
    // on cross-page navigation looks janky and fights browser back/forward.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
}
